import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardDetail from 'components/board/BoardDetail';

// 게시판 관리 > 부처소식 관리 > 상세
export default function DepartmentDetail() {
  const boardType = 'department';

  return (
    <Section>
      <PageTitle title="부처소식 상세" />
      <BoardDetail boardType={boardType} />
    </Section>
  );
}
